(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const setText = (element, value) => { if (element.textContent !== value) element.textContent = value; };
  const initialize = root => {
    if (!mobile.matches) return;
    if (root.parentElement !== document.body) document.body.appendChild(root);
    const section = document.getElementById('MainProduct-' + root.dataset.sectionId);
    const add = section && section.querySelector('form[action*="/cart/add"] button[name="add"]');
    const form = add && add.form;
    if (!section || !form || !add) return;
    const variant = root.querySelector('[data-tsp-variant]');
    const price = root.querySelector('[data-tsp-price]');
    const quantityLabel = root.querySelector('[data-tsp-quantity]');
    const stockLabel = root.querySelector('[data-tsp-stock]');
    const stickyAdd = root.querySelector('[data-tsp-add]');
    let hasBeenVisible = false;
    let pending = false;
    const readVariant = () => {
      const values = [];
      for (const select of form.querySelectorAll('variant-selects select')) {
        const selected = select.selectedOptions && select.selectedOptions[0];
        if (selected) values.push(selected.textContent.trim());
      }
      for (const input of form.querySelectorAll('variant-radios input[type="radio"]:checked')) {
        const label = form.querySelector('label[for="' + input.id.replace(/"/g, '') + '"]');
        values.push(label ? label.textContent.trim() : input.value);
      }
      const title = values.filter(Boolean).join(' / ');
      setText(variant, title);
      const hidden = !title || title === 'Default Title';
      if (variant.hidden !== hidden) variant.hidden = hidden;
    };
    const sync = () => {
      const buttonRect = add.getBoundingClientRect();
      const buttonVisible = buttonRect.bottom > 0 && buttonRect.top < window.innerHeight;
      if (buttonVisible) hasBeenVisible = true;
      const sectionVisible = section.getBoundingClientRect().bottom > 0;
      const show = hasBeenVisible && !buttonVisible && sectionVisible;
      root.hidden = !show;
      document.body.classList.toggle('terla-sticky-purchase-active', show);
      const originalPrice = section.querySelector('.price__sale .price-item--sale') || section.querySelector('.price__regular .price-item--regular') || section.querySelector('.price .price-item--sale') || section.querySelector('.price .price-item--regular');
      if (originalPrice) setText(price, originalPrice.innerText.trim().replace(/\s+/g, ' '));
      const quantity = form.querySelector('input[name="quantity"]');
      setText(quantityLabel, quantity ? 'Quantité : ' + (quantity.value || quantity.min || '1') : '');
      const inStock = !add.disabled;
      setText(stockLabel, inStock ? 'Disponible' : 'Indisponible');
      stickyAdd.disabled = pending || !inStock;
      readVariant();
    };
    stickyAdd.addEventListener('click', () => {
      if (pending || add.disabled || !form.reportValidity()) return;
      pending = true;
      sync();
      add.click();
      window.setTimeout(() => { pending = false; sync(); }, 3000);
    });
    form.addEventListener('change', sync);
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    new MutationObserver(sync).observe(section, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'value', 'class'] });
    sync();
  };
  document.querySelectorAll('[data-terla-sticky-purchase]').forEach(initialize);
})();